import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly TOKEN_KEY = 'admin_token';
  private readonly SESSION_KEY = 'admin_sessionId';
  private readonly EMAIL_KEY = 'admin_email';

  constructor(private http: HttpClient) {}

  login(email: string, password: string): Observable<any> {
    return this.http.post(`${environment.apiUrl}auth/adminlogin`, { email, password }, { withCredentials: true })
      .pipe(
        tap((response: any) => {
          localStorage.setItem(this.TOKEN_KEY, response.token);
          localStorage.setItem(this.SESSION_KEY, response.sessionId);
          localStorage.setItem(this.EMAIL_KEY, email);
        })
      );
  }

  refreshTokens(): Observable<any> {
    return this.http.post(`${environment.apiUrl}auth/refresh`, {}, { withCredentials: true }).pipe(
      tap((response: any) => {
        localStorage.setItem(this.TOKEN_KEY, response.token);
        if (response.sessionId) localStorage.setItem(this.SESSION_KEY, response.sessionId);
      })
    );
  }

  getToken(): string | null {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  /** Nombre y email del admin para el menú de usuario (del token o del login). */
  currentUser(): { name: string; email: string } {
    let payload: any = {};
    try {
      const part = (this.getToken() ?? '').split('.')[1] ?? '';
      payload = JSON.parse(decodeURIComponent(escape(atob(part.replace(/-/g, '+').replace(/_/g, '/')))));
    } catch { /* token sin datos legibles */ }
    const email = payload.email ?? localStorage.getItem(this.EMAIL_KEY) ?? '';
    return { name: payload.name ?? (email ? email.split('@')[0] : 'Admin'), email };
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }

  logout(): void {
    this.http.post(`${environment.apiUrl}auth/logout`, {}, { withCredentials: true }).subscribe({ error: () => {} });
    localStorage.removeItem(this.TOKEN_KEY);
    localStorage.removeItem(this.SESSION_KEY);
    localStorage.removeItem(this.EMAIL_KEY);
  }
}